import { INVOICEID_NO_INVOICE, Charge} from 'lane-shared/domains/billingPayments/types';

export function showServiceRequestChargeStatus(
    isWOInvoicingOptionsFFEnabled: boolean,
    isBPInvoicingDisabled: boolean,
    isSRInvoiceOptionsEnabled: boolean | undefined,
    charge: Charge,
): boolean {
    if (!isWOInvoicingOptionsFFEnabled) return true;

    if (charge.status === 'VOIDED') return true;

    if (isBPInvoicingDisabled) return false;
  
    if (isSRInvoiceOptionsEnabled !== undefined && !isSRInvoiceOptionsEnabled) return false;

    return charge.invoiceId !== INVOICEID_NO_INVOICE;
}